import { render, staticRenderFns } from "./SignUpEmail.vue?vue&type=template&id=cd961bd6&"
import script from "./SignUpEmail.vue?vue&type=script&lang=js&"
export * from "./SignUpEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports